<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">

                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">

                                        <div class="page-body">

                                            <div class="row">
                                                <div class="col-md-12 col-xl-12">
                                                    <div class="card summery-card">
                                                        <div class="card-header">
                                                            <div class="card-header-left ">
                                                                <h5>Applicant Video Upload Instructions</h5>
                                                                <br><br>
                                                                <button v-if="$checkPerm('process.video_instructions.create')"
                                                                    data-toggle="modal" data-target="#newInstruction"
                                                                    class="btn btn-primary btn-md">New Instruction</button>
                                                            </div>
                                                            <!-- <div class="card-header-right">
                                                                <ul class="card-controls">
                                                                    <li><i class="green icofont icofont-refresh reload-card"></i></li>
                                                                    <li><i class="red icofont icofont-maximize full-card"></i></li>
                                                                </ul>
                                                            </div> -->
                                                        </div>
                                                        <div class="card-block">
                                                            <div class="table-responsive">
                                                                <input type="text" class="form-control" v-model="video_filter"
                                                                    placeholder="Search...">
                                                                <datatable :columns="video_columns" :data="video_questions"
                                                                    :filter-by="video_filter" name="video_table"></datatable>
                                                                <div class="" style="text-align: center;">
                                                                    <datatable-pager v-model="page" type="long"
                                                                        :per-page="per_page" table="video_table"></datatable-pager>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="newInstruction" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">New Video Instruction</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="createInstruction">
                            <div class="form-group">
                                <label>Choose opening</label>
                                <select class="form-control" v-model="new_instruction.joblisting_id">
                                    <option v-for="opening in openings" v-bind:value="opening.id">{{opening.role_name}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Instruction</label>
                                <textarea class="form-control" placeholder="Instructions" v-model="new_instruction.instruction"
                                    style="height: 300px;"></textarea>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-md btn-primary">Add</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-for="(video_question, index) in video_questions" v-bind:id="'editInstruction' + video_question.id" class="modal fade"
            role="dialog">
            <div class="modal-dialog modal-lg">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Edit Video for {{video_question.name}} Instruction </h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="editInstruction(video_question.id,index)">
                            <div class="form-group">
                                <label>Choose opening</label>
                                <select class="form-control" v-model="video_questions[index].joblisting_id">
                                    <option v-for="opening in openings" v-bind:value="opening.id">{{opening.role_name}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Instruction</label>
                                <textarea class="form-control" placeholder="Instructions" name="instructions" v-model="video_questions[index].instruction"
                                    style="height: 300px;"></textarea>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-md btn-primary">Edit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- <Tips message='This is the "CBT" section, you can create, update and delete CBT questions for each openings' /> -->
    </div>
</template>
<style>
    .pagination {
        display: inline-block;
    }

    .pagination a {
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
        background: #d5d5d5 !important;
    }

    .pagination a.active {
        background: #4CAF50 !important;
        color: white;
    }

    .pagination a:hover:not(.active) {
        background-color: #00ff00;
    }

    .actions {
        margin-top: 30px;
    }
</style>

<script>
    import navbar1 from '../components/Navbar1.vue'
    import navbar2 from '../components/Navbar2.vue'
    import Tips from '../components/Tips.vue'

    export default {
        name: 'Video',

        data() {
            return {
                video_filter: '',
                page: 1,
                per_page: 10,
                video_columns: [
                    { label: "Opening Name", field: "name", sortable: true },
                    //{label: "Name", field: "role_name", sortable: true},
                    { label: "Video Instruction", field: "instruction", sortable: true },
                    {
                        label: "Action", representedAs: (row) => {
                            var s = ''
                            if (this.$checkPerm('process.video_instructions.edit')) {
                                s = s + '<button class="btn btn-sm btn-warning" data-toggle="modal" data-target="#editInstruction' + row.id + '">Edit</button>&nbsp;'
                            }
                            //if (this.$checkPerm('process.video_instructions.delete')) {
                            // s = s + '&nbsp;<button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#deleteInstruction' + row.id + '">Delete</button>'
                            //}

                            return s
                        }, sortable: true, interpolate: true
                    }
                ],

                video_questions: [],

                new_instruction: {
                    joblisting_id: '',
                    instruction: ''
                },

                openings: []
            }
        },

        components: {
            navbar1,
            navbar2,
            Tips
        },

        mounted() {
            this.getVideos()
            this.getOpenings()
        },
        methods: {
            getVideos() {

                var i_videos = {
                    what: "InterviewVideos"
                }

                this.$socket.makeGetRequest(i_videos)
                    .then((response) => {
                        if (response.type == 'InterviewVideos' && response.status == 'true') {
                            console.log(response)
                            this.video_questions = response.data

                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            getOpenings() {

                var get_openings_request = {
                    what: 'openings'
                }

                this.$socket.makeGetRequest(get_openings_request)
                    .then((response) => {
                        if (response.type == 'openings') {
                            console.log(response)
                            this.openings = response.data
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                    })
            },

            createInstruction() {
                console.log(this.new_instruction)
                var v_instructions = {
                    what: 'VideoUploadInstructions',
                    data: this.new_instruction
                }

                this.$socket.makePostRequest(v_instructions)
                    .then((response) => {
                        if (response.type == 'VideoUploadInstructions' && response.status == "true") {
                            window.alert("Instruction created successfully.")

                            setTimeout(() => {
                                window.location.reload()
                            }, 1000)
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            editInstruction(id, index) {
                var editInstruction = {
                    what: 'VideoUploadInstructions',
                    id: id,
                    data: this.video_questions[index]
                }
                console.log(this.video_questions[index])
                this.$socket.makeEditRequest(editInstruction)
                    .then((response) => {
                        console.log(response)
                        this.$swal.fire('Success', response.data.message, 'success')
                        setTimeout(() => {
                            window.location.reload()
                        }, 5000)
                    })
                    .catch((error) => {
                        console.log(error)
                        this.$swal.fire('Error', error.data.message, 'error')
                    })
            }
        },
        computed: {

        }
    }
</script>